import React, { useState, useEffect } from "react";
import { useListing } from "@/providers";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import CustomPortal from "../custom-portal";

export const DetailsImages = () => {
  const { listingDetails } = useListing();
  const { images } = listingDetails;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== "undefined" ? window.innerWidth : 0,
    height: typeof window !== "undefined" ? window.innerHeight : 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Convert images to the format required by react-image-gallery
  const galleryImages = images?.map((image) => ({
    original: image.image,
    thumbnail: image.image,
    description: image.description || "",
    originalHeight: windowSize.width < 768 ? "auto" : "80vh",
  }));

  const handleImageClick = () => {
    setIsModalOpen(true);
    // Disable body scroll when modal is open
    document.body.style.overflow = "hidden";
  };

  const toggleModal = () => {
    setIsModalOpen((open) => !open);
    // Re-enable body scroll when modal is closed
    document.body.style.overflow = "auto";
  };

  // Responsive thumbnail grid configuration
  const getThumbnailGrid = () => {
    if (windowSize.width < 640) {
      // Mobile - single column with larger images
      return (
        <div className="grid grid-cols-1 gap-4 px-4">
          {images?.map((image, index) => (
            <div key={index} className="h-[30vh]">
              <img
                src={`${image?.image}`}
                alt=""
                className="object-cover w-full h-full rounded-lg cursor-pointer"
                onClick={handleImageClick}
              />
            </div>
          ))}
        </div>
      );
    } else if (windowSize.width < 768) {
      // Small tablets - 2 columns
      return (
        <div className="grid grid-cols-2 gap-3 px-4">
          {images?.map((image, index) => (
            <div key={index} className="h-[25vh]">
              <img
                src={`${image?.image}`}
                alt=""
                className="object-cover w-full h-full rounded-lg cursor-pointer"
                onClick={handleImageClick}
              />
            </div>
          ))}
        </div>
      );
    } else {
      // Desktop - featured image + 4 thumbnails
      return (
        <div className="grid grid-cols-1 gap-4 px-4 md:px-6 lg:px-10 md:grid-cols-2">
          <div className="h-[40vh] md:h-[50vh] lg:h-[60vh]">
            {images?.[0] && (
              <img
                src={`${images[0]?.image}`}
                alt=""
                className="object-cover w-full h-full rounded-lg cursor-pointer"
                onClick={handleImageClick}
              />
            )}
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4 md:grid-rows-2 md:grid-cols-2">
            {images?.slice(1, 5).map((image, index) => (
              <div
                key={index}
                className="h-[18vh] sm:h-[20vh] md:h-[24vh] lg:h-[28vh]"
              >
                <img
                  src={`${image?.image}`}
                  alt=""
                  className="object-cover w-full h-full rounded-lg cursor-pointer"
                  onClick={handleImageClick}
                />
              </div>
            ))}
          </div>
        </div>
      );
    }
  };

  return (
    <div className="relative">
      {/* Thumbnail Grid */}
      {getThumbnailGrid()}

      {/* Modal Gallery */}
      {/* {isModalOpen && (
        <CustomPortal>
          <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-[9999999]">
            <button
              onClick={toggleModal}
              className="absolute z-50 flex items-center justify-center w-10 h-10 p-2 text-2xl font-bold text-white transition-all duration-200 bg-black bg-opacity-50 rounded-full top-4 right-4 hover:bg-opacity-70"
              aria-label="Close gallery"
            >
              &times;
            </button>

            <div className="w-full h-full p-4 mx-auto sm:p-6 md:p-8 max-w-7xl">
              <ImageGallery
                items={galleryImages}
                showPlayButton={false}
                showFullscreenButton={windowSize.width > 768}
                showNav={windowSize.width > 480}
                showBullets={windowSize.width <= 480}
                autoPlay={false}
                slideDuration={450}
                slideInterval={3000}
                additionalClass="image-gallery-custom h-full"
                onScreenChange={(fullScreen) => !fullScreen && toggleModal()}
                renderItem={(item) => (
                  <div className="flex items-center justify-center h-full">
                    <img
                      src={item.original}
                      alt={item.description}
                      className="object-contain max-h-[80vh] w-auto"
                    />
                  </div>
                )}
                renderThumbInner={(item) => (
                  <img
                    src={item.thumbnail}
                    alt={item.description}
                    className="object-cover h-full"
                  />
                )}
              />
            </div>
          </div>
        </CustomPortal>
      )} */}

      {isModalOpen && (
        <CustomPortal>
          <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-[9999999]">
            <button
              onClick={toggleModal}
              className="absolute z-50 flex items-center justify-center w-10 h-10 p-2 text-2xl font-bold text-white transition-all duration-200 bg-black bg-opacity-50 rounded-full top-4 right-4 hover:bg-opacity-70"
              aria-label="Close gallery"
            >
              &times;
            </button>

            <div className="w-full h-full p-4 mx-auto sm:p-6 md:p-8 max-w-7xl">
              <ImageGallery
                items={galleryImages}
                showPlayButton={false}
                showFullscreenButton={windowSize.width > 768}
                showNav={windowSize.width > 480}
                showBullets={windowSize.width <= 480}
                autoPlay={false}
                slideDuration={450}
                slideInterval={3000}
                additionalClass="image-gallery-custom h-full"
              />
            </div>
          </div>
        </CustomPortal>
      )}
    </div>
  );
};
